import { type SVGProps } from 'react';
import { type IconProps } from '@/components/uielements/icon/types';

/**
 * A cloud with a strike-through, used to convey that online ordering is temporarily
 * offline (a POS refusal) — TEAM-14640.
 */
export const CloudOff = ({
  title,
  width,
  height,
  ...otherProps
}: IconProps & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...otherProps}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width ?? '24'}
      height={height ?? '24'}
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <title>{title ?? 'Ordering offline'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 15a4.5 4.5 0 0 0 4.5 4.5h9.75a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 3.75 20.25 21" />
    </svg>
  );
};
